import styled from 'styled-components'

/**
 * @component container for a checkbox followed by a message/label
 */
export default styled.div`
  display: flex;
  align-items: center;
`
